export enum GlobalPadding {
  Desktop = '170px',
}
